module.exports = __webpack_public_path__ + "63ae7a95647e79bcb67be1d946ab71d5.pdf";